import fetch from 'isomorphic-fetch';

function fetchWithTimeout(requestInfo: RequestInfo, options: RequestInit, timeout: number) {
  // Inject the Connection: Keep-Alive header
  if (options.headers) {
    options.headers['connection'] = 'keep-alive';
  } else {
    options.headers = {
      connection: 'keep-alive',
    };
  }

  if (typeof timeout !== 'number' || timeout === 0) {
    return fetch(requestInfo, options);
  }

  const controller = new AbortController();
  const { signal } = controller;

  const timer = setTimeout(() => {
    controller.abort();
  }, timeout);

  return fetch(requestInfo, { ...options, signal }).finally(() => clearTimeout(timer));
}

export { fetchWithTimeout };
